import { useEffect, useState } from "react";
import { imageUrl } from "@/api";

// `w` picks a small server-side variant (200 / 600 / 1200) so we never pull a
// multi-MB original into a thumbnail.
export const FabricImage = ({ path, alt, className, onClick, w = 600, ...rest }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    setSrc(imageUrl(path, w));
  }, [path, w]);

  if (!path || !src)
    return (
      <div className={`flex items-center justify-center bg-zinc-100 ${className}`} {...rest}>
        <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-400">No image</span>
      </div>
    );

  return <img src={src} alt={alt} loading="lazy" className={className} onClick={onClick} {...rest} />;
};
